import React from 'react';
import { env } from 'constants';
import CateringHeader from './CateringHeader';
import GeneralHeader from './GeneralHeader';

function Header(props) {
  return env.IS_CATERING ? <CateringHeader {...props} /> : <GeneralHeader {...props} />;
}

export default Header;
